import { datadogRum } from '@datadog/browser-rum';
import { StorageKey, storage } from 'utils/typedStorage';

/**
 * Attaches the signed-in user to RUM events.
 *
 * The call runs during render rather than in an effect: child effects run
 * before the parent's, so anything a child reports on mount would be recorded
 * without a user if this waited for Layout's effects.
 *
 * The name is whatever the two stored halves hold at render time. They are
 * written after the session store commits, so early renders report them as
 * absent.
 */
export const useDatadogRumUser = (
  userId: string | null,
  userEmail: string | null
): void => {
  const userName = `${storage.get(StorageKey.FirstName)} ${storage.get(StorageKey.LastName)}`;

  if (userId && userEmail) {
    datadogRum.setUser({
      id: userId,
      email: userEmail,
      name: userName,
    });
  }
};
